import { Parish } from './parish';
import { StudentMaxOut } from './student.maxout';

export class Sponsor {

    id: number;
    title: string;
    firstName: string;
    lastName: string;
    nickName: string;
    middleInitial: string;
    dayOfBirth: number;
    monthOfBirth: number;
    sponsorStatus: number;
    phone1: string;
    sponsorCode: string;
    emailAddress: string;
    promoterEmail: string;
    appartmentNumber: string;
    street: string;
    city: string;
    state: string;
    postalCode: number;
    hasAnyCoSponser: boolean;
    parishId: number;
    parishName: string;
    parishCity: string;
    centerId: number;
    coSponserName: string;
    coSponserFirstName: string;
    coSponserLastName: string;
    coSponserRelationShip: string;
    paymentDate: string;
    contributionAmount: number;
    effectiveDate: string;
    createdBy: number;
    updatedBy: number;

    entId: number;
    enrollmentId:number;
    noOfStudents: number;
    expirationMonth: number;
    expirationYear: number;
    miscAmount: number;
    enrollmentStatus: string = 'NA';
    maxOut: Date;

    type: string;
    amount: number;
    netAmount: number;
    sponsorReceiptId: number

    studentMaxouts: Array<StudentMaxOut>;
    //effectiveDate: Date;
}
